module.exports = __webpack_public_path__ + "static/media/hod-desk-img.74432582.jpg";